module.exports = __webpack_public_path__ + "static/media/logs.58e29947.png";